<template>
    <div>
        <nav class="tabbed-navigation">
            <a v-for="region in regions" @click.prevent="toggleContinent(region.slug)" href="#" class="tabbed-navigation__item" :class="{ 'active' : isActive(region.slug) }" v-html="region.name"></a>
        </nav>
        <div v-cloak v-for="region in regions" v-show="isActive(region.slug)" class="city-navigation">
            <nav v-for="country in region.countries" class="city-navigation__country" :class="`country--${country.slug}`">
                <p class="city-navigation__title">
                    <span class="flag" :class="`flag--${country.slug}`"></span>
                    <a v-if="country.slug !== 'ae'" :href="`${networkUrl}${country.slug}/`">{{ country.name }}</a>

                    <span v-else @click.prevent>{{ country.name}}</span>
                </p>
                <a v-for="location in country.locations" :href="location.url + `/`" class="city-navigation__item" v-html="location.title"></a>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            regions: {
                required: true
            },
            networkUrl: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                activeContinent: 'europe'
            }
        },

        methods: {
            toggleContinent(continent) {
                this.activeContinent = continent;
            },

            isActive(continent) {
                return this.activeContinent === continent;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/LocationNavigation.vue